import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import IRestaurantInfo from 'models/IRestaurantInfo'

export interface HelmetProps {
  children: React.ReactNode
}

export const useHelmet = (props: HelmetProps) => {
  const restaurantInfo: IRestaurantInfo | null = useSelector(
    (state: RootState) => state.restaurantInfo.restaurantInfo
  )

  return {
    ...props,
    ...restaurantInfo,
  }
}
